// PC タブインデックスリストを追加
function addTabIndexList() {
  Array.from(document.querySelectorAll("#menuContents .tab-content")).forEach((tabContent) => {
    const element = document.createElement("div");

    element.classList.add("tab-index");
    element.setAttribute("data-index-id", tabContent.id);
    element.textContent = tabContent.getAttribute("data-content-title");
    element.addEventListener("click", () => {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('tab', tabContent.id); // 'tab'クエリパラメータを更新
      window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
      handleUrlChange(); // ページをリロードせずにタブの表示を更新
    });

    document.querySelector("#tabIndexList").appendChild(element);
  });
}

// SP カテゴリインデックス要素を作成
function addCategoryIndexList() {
  Array.from(document.querySelectorAll(".tab-content")).forEach((tabContent) => {
    const categoryListElement = document.createElement("ul");
    const fragment = document.createDocumentFragment();

    categoryListElement.classList.add("tab__category-list");
    Array.from(tabContent.querySelectorAll(".category__title")).forEach((categoryTitle) => {
      const listItem = document.createElement("li");
      const sectionId = categoryTitle.closest('.category').id;
      listItem.innerHTML = `<a href="/pages/faq?tab=${tabContent.id}#${sectionId}">${categoryTitle.textContent}</a>`;
      fragment.appendChild(listItem);
    });

    categoryListElement.appendChild(fragment);

    document.querySelector(`[data-content-id="${tabContent.id}"]`).insertAdjacentElement("afterend", categoryListElement);
  });
}

// アクティブ属性を設定
function setActiveAttributeBasedOnQueryParam(elements, param, attribute = "active") {
  elements.forEach(element => {
    const targetId = element.dataset.indexId || element.id;
    element.toggleAttribute(attribute, targetId === param);
  });
}

// URLを解析する関数
function parseUrlSearchParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const tab = urlParams.get('tab');
  const category = window.location.hash.slice(1);
  return { tab, category };
}

// 指定の要素の背景色を変更する関数
function changeColor(element, color, duration) {
  const initialColor = element.style.backgroundColor || 'rgba(255, 255, 255, 0)';
  setTimeout(() => {
    // 背景色を変更
    element.style.transition = `background-color ${duration / 1000}s ease`;
    element.style.backgroundColor = color;
  }, 500);

  // 1秒後に背景色を元に戻す
  setTimeout(() => {
    element.style.backgroundColor = initialColor;
  }, 1500);
}

// URL変更時の処理
function handleUrlChange() {
  const { tab, category } = parseUrlSearchParams();

  setActiveAttributeBasedOnQueryParam(Array.from(document.querySelectorAll(".tab-index, .tab-content")), tab);

  if (!!tab) {
    document.querySelector('.back-btn').classList.add('active');
    document.querySelector("#menuList").style.display = "none";
    document.querySelector("#menuContents").style.display = "block";
  } else {
    document.querySelector('.back-btn').classList.remove('active');
    document.querySelector("#menuList").style.display = "block";
    document.querySelector("#menuContents").style.display = "none";
  }

  if (!!category) {
    const target = $(`#${category}`);
    const accordionContent = target.find('.accordion__content');
    const accordionTrigger = target.find('.accordion__trigger');

    // アコーディオンのコンテンツが既に表示されているかを確認
    if (!accordionContent.is(':visible')) {
      // アコーディオンが閉じている場合のみ、トリガーをクリックして開く
      accordionTrigger.click();
    }
    // 背景色を変更
    // changeColor(target[0], 'rgba(255, 255, 0, 0.2)', 500);
  } else {
    window.scrollTo(0, 0);
  }

  window.addEventListener('scroll', () => {
    const stickyHeader = document.querySelector('sticky-header');
    const backBtn = document.querySelector('.back-btn.active');
    if (!!backBtn) {
      if (backBtn.getBoundingClientRect().top < stickyHeader.offsetHeight) {
        document.querySelector('.back-btn.back-btn--float').classList.add('active');
      } else {
        document.querySelector('.back-btn.back-btn--float').classList.remove('active');
      }
    }
  });
}

// イベントリスナーの設定
function setupEventListeners() {
  document.querySelectorAll(".tab__category-title").forEach(menu => {
    menu.addEventListener("click", () => {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('tab', menu.dataset.contentId);
      window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
      handleUrlChange();
    });
  });
  
  Array.from(document.querySelectorAll(".back-btn")).forEach((button) => button.addEventListener("click", () => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('tab');
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
    handleUrlChange();
  }));

  window.addEventListener("popstate", handleUrlChange);

  window.addEventListener('scroll', () => {
    const stickyHeader = document.querySelector('.section-header');
    const main = document.querySelector('main');

    stickyHeader.style.position = 'sticky';
    main.style.marginTop = 0;

    if (stickyHeader.getBoundingClientRect().top <= 0) {
      stickyHeader.style.position = 'fixed';
      main.style.marginTop = `${stickyHeader.offsetHeight}px`;
    }

    Array.from(document.querySelectorAll('.accordion__trigger.question.active')).forEach((question) => {
      const answer = question.nextElementSibling;
      if (question.getBoundingClientRect().bottom <= answer.getBoundingClientRect().top) {
        question.classList.remove('is-sticky');
      } else {
        question.classList.add('is-sticky');
      }
    });
  });
}

// 初期化
function initialize() {
  if (window.innerWidth >= 750) {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('tab')) {
      urlParams.set('tab', 'customer-service');
      window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
    }
    Array.from(document.querySelectorAll(".back-btn")).forEach((button) => button.style.display = "none");
    addTabIndexList();
    setupEventListeners();
    handleUrlChange();
  } else {
    addCategoryIndexList();
    setupEventListeners();
    handleUrlChange();
    document.querySelector("#tabIndexList").style.display = "none";
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('tab')) {
      document.querySelector("#menuList").style.display = "block";
    } else {
      document.querySelector("#menuList").style.display = "none";
    }
  }
}

// 初期化
window.addEventListener("DOMContentLoaded", initialize);


$(function () {
  $('.accordion__content').hide();
  $('.accordion__trigger').removeClass('active');

  if (window.innerWidth >= 750) {
    $('.category > .accordion__content').show();
    $('.category > .accordion__trigger').addClass('active');
  }

  $('.accordion__trigger').click(function slideToggle() {
    if ($(this).parent().hasClass('category') && window.innerWidth >= 750) {
      return false;
    } else {
      $(this).next('.accordion__content').slideToggle();
      $(this).toggleClass("active");
    }
  });
});

